import React from 'react';
import moment from "moment";
import "moment/locale/es";
moment.locale("mx");

export const Productividad = () => {
  return(
    <div className="container-fluid">
      <div className="ws-main-container">

        <div className="row">
          <div className="col-12">
            <div className="ws-box-container">
              {/* {<div className="ws-loader-container"><div className="spinner"></div></div>} */}
              <h4>Productividad</h4>

            </div>
          </div>
        </div>
      </div>
    </div>
  ) 
}